<app-spinner *ngIf="isSpinner" [isSpinning]="isSpinner"></app-spinner>
<div class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ liveMessage }}</div>
<div class="demo-question-header" *ngIf="!isSpinner">
  <div class="demo-progress-label">
    <span>{{'demoBadge' | translate}}</span>
    <span>{{'question' | translate}} {{questionIndex}} {{'demoOf' | translate}} {{total}}</span>
  </div>
  <div class="demo-progress-bar" [attr.aria-valuenow]="questionIndex" aria-valuemin="1" [attr.aria-valuemax]="total">
    <div class="demo-progress-fill" [style.width.%]="progressPercent"></div>
  </div>
  <p class="demo-fallback-notice" *ngIf="isFallback">{{'demoFallbackNotice' | translate}}</p>
</div>

<div class="question-container" *ngIf="!isSpinner">
  <nz-card class="card-body">
    <div class="question-wrapper" *ngIf="question.questionText">
      <div class="answer-wrapper">
        <div class="question-image-wrapper" *ngIf="question.image">
          <img src="{{question.image}}" alt="question-image">
        </div>
        <div class="question-text" id="question-text-label">
          <span class="question-id">{{questionIndex}}.</span>
          <span>{{question.questionText}}</span>
        </div>
        <div class="options-group" role="group" aria-labelledby="question-text-label">
        <nz-list
          nzSize="small"
          *ngFor="let option of question.options; let i = index"
        >
          <nz-list-item>
            <div *ngIf="option"
              role="checkbox"
              tabindex="0"
              [attr.aria-checked]="answer.userCheck[i] ? 'true' : 'false'"
              [attr.aria-label]="optionAriaLabel(i)"
              (click)="checkOption(i)"
              (keydown.enter)="onOptionKey($event, i)"
              (keydown.space)="onOptionKey($event, i)"
              [ngClass]="checkAnswer ? optionTextCssClass(i) : 'answer'">
              <div [ngClass]="optionCssClass(i)" aria-hidden="true">
                {{ options[i] }}
                <span class="option-state-icon" *ngIf="checkAnswer">{{ optionStateIcon(i) }}</span>
              </div>
              <div class="option-body" aria-hidden="true">
                <span>{{ option }}</span>
                <div class="option-state-label" *ngIf="optionStateKey(i)" [ngClass]="optionStateLabelClass(i)">
                  <span class="option-state-symbol">{{ optionStateIcon(i) }}</span>
                  {{ optionStateKey(i) | translate }}
                </div>
              </div>
            </div>
            <div
              *ngIf="checkAnswer && answer.optionHint[i]"
              [ngClass]="explanationCssClass(i)"
            >
              <span>{{ answer.optionHint[i] }}</span>
            </div>
          </nz-list-item>
        </nz-list>
        </div>

        <div class="question-source" *ngIf="checkAnswer && (question.sourceLink || question.sourceName)">
          <div>
            <span>
              {{'source' | translate}}
            </span>
          </div>
          <div class="source">
            <a *ngIf="question.sourceLink" href="{{question.sourceLink}}" target="_blank" rel="noopener noreferrer">
              {{ question.sourceName ? question.sourceName : question.sourceLink}}
            </a>
            <span *ngIf="!question.sourceLink">{{ question.sourceName }}</span>
          </div>
        </div>
      </div>
      <div class="button-wrapper">
        <div *ngIf="!hasPrevious"></div>
        <button *ngIf="hasPrevious" (click)="prevQuestion()" nzSize="large" [ngClass]="'outline-button'" class="prev-button"
                nz-button nzGhost>
          <i nz-icon nzType="left"></i>{{'previous' | translate}}
        </button>
        <button
          nzSize="large"
          [ngClass]="
            checkAnswer ? 'check-answer-button-disabled' : 'check-answer-button'
          "
          nz-button
          [disabled]="checkAnswer"
          (click)="sendAnswer()"
        >
          {{'checkAnswer' | translate}}
        </button>
        <button *ngIf="hasNext" (click)="nextQuestion()" nzSize="large" [ngClass]="'outline-button'"
                nz-button nzGhost>
          {{'next' | translate}}<i nz-icon nzType="right"></i>
        </button>
        <button *ngIf="!hasNext" (click)="finishDemo()" nzSize="large" [ngClass]="'outline-button'"
                nz-button nzGhost>
          {{'finish' | translate}}<i nz-icon nzType="right"></i>
        </button>
      </div>
      <div class="button-wrapper-mobile">
        <div class="prev-next-wrapper">
          <button
            (click)="prevQuestion()"
            nzSize="large"
            [ngClass]="{ visibility_hidden: !hasPrevious }"
            class="outline-button prev-button"
            nz-button
            nzGhost
          >
            <i nz-icon nzType="left"></i>{{'previous' | translate}}
          </button>
          <button
            *ngIf="hasNext"
            (click)="nextQuestion()"
            nzSize="large"
            [ngClass]="'outline-button'"
            nz-button
            nzGhost
          >
          {{'next' | translate}}<i nz-icon nzType="right"></i>
          </button>
          <button
            *ngIf="!hasNext"
            (click)="finishDemo()"
            nzSize="large"
            [ngClass]="'outline-button'"
            nz-button
            nzGhost
          >
          {{'finish' | translate}}<i nz-icon nzType="right"></i>
          </button>
        </div>
        <div class="check-answer-wrapper">
          <button
            nzSize="large"
            [ngClass]="
              checkAnswer
                ? 'check-answer-button-disabled'
                : 'check-answer-button'
            "
            nz-button
            [disabled]="checkAnswer"
            (click)="sendAnswer()"
          >
          {{'checkAnswer' | translate}}
          </button>
        </div>
      </div>
    </div>
  </nz-card>
</div>
